import type * as THREE from 'three';

/**
 * Checks if the given point is matchs to the Vector3Like interface.
 */
export const isVector3Like = (v: unknown): v is THREE.Vector3Like => {
  return !!(v && typeof v === 'object' && 'x' in v && 'y' in v && 'z' in v);
};
